import React from "react";

const BaseInnerSubtitle = (props) => {
  return (<h3 className={`${props.custom ? props.custom : ""} 
                        ${props.extra ? props.extra : ""} 
                          ${props.col ? `p-col-${props.col}` : "p-col-12"}
                          `}
    {...props}>
    {props.children}
  </h3>);
};

export default BaseInnerSubtitle;